import Swiper, { Autoplay, Pagination, Keyboard, EffectFade, Mousewheel } from "swiper";

export const verticalSliderOptions = {
  modules: [Pagination, Autoplay, Keyboard, Mousewheel, EffectFade],
  // If we need pagination
  direction: "vertical",
  effect: "fade",
  spaceBetween: 30,
  threshold: 400,
  keyboard: {
    enabled: true,
  },
  mousewheel: {
    releaseOnEdges: true,
  },
  touchReleaseOnEdges: true,
  pagination: {
    el: ".vertical-swiper-pagination",
    clickable: true,
    type: "bullets",
  },
  autoplay: true,
}